import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container-fluid px-4 py-5">
        {/* Hero Section */}
        <section className="hero-section text-center mb-5">
          <span className="eyebrow">About Us</span>
          <h1 className="display-4 fw-bold mb-3">About SRK Production</h1>
          <p className="lead fs-5">
            Bringing creativity, innovation, and excellence to every project we undertake
          </p>
        </section>

        {/* Mission Section */}
        <section className="mission-section mb-5">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="section-title mb-4">Our Mission</h2>
              <p className="section-text">
                At SRK Production, we are dedicated to creating compelling experiences that inspire, 
                entertain, and connect people. Our mission is to produce high-quality content and events 
                that celebrate talent, foster creativity, and build meaningful communities.
              </p>
              <p className="section-text">
                We believe in the power of storytelling and the importance of bringing diverse voices 
                to the forefront. Through our events and productions, we aim to make a positive impact 
                on society and create lasting memories for our audience.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="mission-box">
                <div className="mission-icon mission-lottie mb-3" aria-hidden="true">
                  <DotLottieReact
                    src="https://lottie.host/87a4067f-2016-44d6-943b-a889c8b1cf2e/JESD1Z0dAH.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h3 className="fw-bold mb-3">Creative Excellence</h3>
                <p>We strive for excellence in every aspect of our work, from concept to execution.</p>
              </div>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="services-section mb-5">
          <h2 className="section-title text-center mb-5">What We Do</h2>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="service-card">
                <div className="service-icon service-lottie" aria-hidden="true">
                  <DotLottieReact
                    src="https://lottie.host/f91df731-d76d-497e-9017-fd8186a12f0f/jguvpx4flc.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h3 className="fw-bold mb-3">Events & Shows</h3>
                <p>We organize and produce world-class events, concerts, and performances that captivate audiences.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="service-card">
                <div className="service-icon service-lottie" aria-hidden="true">
                  <DotLottieReact
                    src="https://lottie.host/87a4067f-2016-44d6-943b-a889c8b1cf2e/JESD1Z0dAH.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h3 className="fw-bold mb-3">Content Production</h3>
                <p>From concept to final cut, we create engaging visual content that tells powerful stories.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="service-card">
                <div className="service-icon service-lottie" aria-hidden="true">                  
                <DotLottieReact
                    src="https://lottie.host/4b2f162a-80bd-455f-8b7f-d373b689d721/Gdzj9AOVOW.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h3 className="fw-bold mb-3">Artist Management</h3>
                <p>We support and nurture talent, helping artists reach their full potential and broader audiences.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section mb-5">
          <h2 className="section-title text-center mb-5">Our Values</h2>
          <div className="row">
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="value-item">
                <h4 className="fw-bold mb-2">Integrity</h4>
                <p>We operate with transparency and honesty in all our dealings.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="value-item">
                <h4 className="fw-bold mb-2">Innovation</h4>
                <p>We continuously seek new ways to push creative boundaries.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="value-item">
                <h4 className="fw-bold mb-2">Collaboration</h4>
                <p>We believe in the power of teamwork and community partnerships.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="value-item">
                <h4 className="fw-bold mb-2">Excellence</h4>
                <p>We maintain the highest standards in everything we do.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section mb-5">
          <h2 className="section-title text-center mb-5">Our Team</h2>
          <p className="text-center section-text mb-5">
            Our diverse team of creative professionals brings unique perspectives and expertise to every project. 
            Together, we transform ideas into unforgettable experiences.
          </p>
          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="team-card">
                <div className="service-icon service-lottie" aria-hidden="true">                  
                <DotLottieReact
                    src="https://lottie.host/893c7716-6057-4da4-b795-0c997791f1cf/Rpqspih8dJ.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h4 className="fw-bold mt-3">Leadership</h4>
                <p className="small">Visionary directors guiding our creative direction</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="team-card">
                <div className="service-icon service-lottie" aria-hidden="true">                  
                <DotLottieReact
                    src="https://lottie.host/230b3a86-f01a-4bb1-bee1-d28bd1eec8c0/0gL9HGbeKk.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h4 className="fw-bold mt-3">Creative Team</h4>
                <p className="small">Designers, producers, and creators bringing ideas to life</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="team-card">
                <div className="service-icon service-lottie" aria-hidden="true">                  
                <DotLottieReact
                    src="https://lottie.host/fa11b46c-0b8f-4e75-ab87-012a4b0c13e4/TLg8uFqdeS.lottie"
                    loop
                    autoplay
                  />
                </div>
                <h4 className="fw-bold mt-3">Technical Experts</h4>
                <p className="small">Technology and innovation specialists</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section text-center py-5">
          <h2 className="mb-3">Join Us Today</h2>
          <p className="fs-5 mb-4">
            Be part of our creative journey. Register for our upcoming events and experiences.
          </p>
          <a href="/events" className="btn btn-register fw-bold text-uppercase px-5 py-3">
            Get Started
          </a>
        </section>
      </div>
    </div>
  );
};

export default About;
